import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PAGE_HEADER_AUTHOR_SX, PAGE_HEADER_TITLE_BLOCK_SX, PAGE_HEADER_TITLE_SX } from '../styles';

import type { PageHeaderTitleProps } from './types';

export default function PageHeaderTitle({ authorName }: PageHeaderTitleProps) {
  const { t } = useTranslation('header');

  return (
    <Box sx={PAGE_HEADER_TITLE_BLOCK_SX}>
      <Typography component="h1" sx={PAGE_HEADER_TITLE_SX}>
        {t('treatmentPlan')}
      </Typography>
      <Typography sx={PAGE_HEADER_AUTHOR_SX}>
        <Box component="span" fontFamily="DMSansBold">
          {t('author')}
        </Box>{' '}
        {authorName}
      </Typography>
    </Box>
  );
}
